/* ms-line-cta-track.js
 *
 * 記事内の LINE CTA のクリックを記録する。
 *
 * ★このサイトの GA4 は Shopify の web-pixels 経由(測定ID G-FKT1EL8RMC)で入っており、
 *   テーマから window.gtag を直接呼べない。そのため次の順で送信を試みる:
 *
 *   1. Shopify.analytics.publish(...)  … Customer Events(Web Pixel)へ流す。本命
 *   2. window.gtag(...)                … gtag が露出している環境向けの保険
 *   3. window.dataLayer.push(...)      … GTM がある場合の保険
 *
 *   1 を受け取るには、Shopify管理画面 > 設定 > カスタマーイベント で
 *   カスタムピクセルを1つ作り、analytics.subscribe('ms_line_cta_click', ...) で
 *   GA4 へ転送する必要がある(手順は R16_GA4_SETUP.md)。
 *
 * リンク側の属性(line_cta_patch.py が付与済み):
 *   data-article / data-type / data-position / data-offer
 */
(function () {
  'use strict';

  var EVENT_NAME = 'ms_line_cta_click';

  function payloadFrom(link) {
    return {
      article_handle: link.getAttribute('data-article') || '',
      article_type: link.getAttribute('data-type') || '',
      cta_position: link.getAttribute('data-position') || '',
      offer: link.getAttribute('data-offer') || '',
      link_url: link.href || '',
      page_path: window.location.pathname
    };
  }

  function send(link) {
    var data = payloadFrom(link);

    // 1) Shopify Customer Events(このストアの本命経路)
    try {
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(EVENT_NAME, data);
      }
    } catch (e) { /* 送信失敗でも遷移は止めない */ }

    // 2) gtag が露出している場合
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'line_cta_click',
          Object.assign({ transport_type: 'beacon' }, data));
      }
    } catch (e) { /* noop */ }

    // 3) GTM の dataLayer がある場合
    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: 'line_cta_click' }, data));
      }
    } catch (e) { /* noop */ }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var link = target.closest('a.line-cta');
    if (!link) return;
    send(link);
  }, true);
})();
